import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SCREEN_TABS_HISTORY_TYPE } from '../constants';
import { normalizeFieldsAppliedChangesForHistory } from './utils/normalize-changes';
var prepareAppliedChangesHistoryForSingleChange = function prepareAppliedChangesHistoryForSingleChange(_ref) {
  var _currentAppliedChange, _appliedChangesHistor, _appliedChangesHistor2, _appliedChangesHistor3;
  var currentAppliedChangesHistory = _ref.currentAppliedChangesHistory,
    appId = _ref.appId,
    changeId = _ref.changeId,
    newSingleAppChange = _ref.newSingleAppChange;
  var appliedChangesHistoryChangeId = (_currentAppliedChange = currentAppliedChangesHistory[changeId]) !== null && _currentAppliedChange !== void 0 ? _currentAppliedChange : {};
  var appliedChangesHistoryChangeIdApp = (_appliedChangesHistor = (_appliedChangesHistor2 = appliedChangesHistoryChangeId.apps) === null || _appliedChangesHistor2 === void 0 ? void 0 : _appliedChangesHistor2[appId]) !== null && _appliedChangesHistor !== void 0 ? _appliedChangesHistor : {};
  return _objectSpread(_objectSpread({}, currentAppliedChangesHistory), {}, _defineProperty({}, changeId, {
    apps: _objectSpread(_objectSpread({}, appliedChangesHistoryChangeId.apps), {}, _defineProperty({}, appId, _objectSpread(_objectSpread({}, appliedChangesHistoryChangeIdApp), newSingleAppChange))),
    createdAt: (_appliedChangesHistor3 = appliedChangesHistoryChangeId.createdAt) !== null && _appliedChangesHistor3 !== void 0 ? _appliedChangesHistor3 : Date.now()
  }));
};
export var collectScreenTabsAppliedChangesHistory = function collectScreenTabsAppliedChangesHistory(_ref2) {
  var appId = _ref2.appId,
    changeId = _ref2.changeId,
    screenTabs = _ref2.screenTabs;
  return function (_ref3) {
    var setState = _ref3.setState,
      getState = _ref3.getState;
    var _getState = getState(),
      appliedChangesHistory = _getState.appliedChangesHistory;
    if (!screenTabs.length) {
      return;
    }
    var newAppliedChangesHistory = prepareAppliedChangesHistoryForSingleChange({
      currentAppliedChangesHistory: appliedChangesHistory,
      appId: appId,
      changeId: changeId,
      newSingleAppChange: {
        tabs: {
          type: SCREEN_TABS_HISTORY_TYPE
        }
      }
    });
    setState({
      appliedChangesHistory: newAppliedChangesHistory
    });
  };
};
export var collectFieldsAppliedChangesHistory = function collectFieldsAppliedChangesHistory(_ref4) {
  var appId = _ref4.appId,
    changeId = _ref4.changeId,
    fieldsChanges = _ref4.fieldsChanges;
  return function (_ref5) {
    var setState = _ref5.setState,
      getState = _ref5.getState;
    var _getState2 = getState(),
      appliedChangesHistory = _getState2.appliedChangesHistory,
      internalFormMetadata = _getState2.internalFormMetadata;
    var singleAppChange = normalizeFieldsAppliedChangesForHistory({
      fieldsChanges: fieldsChanges,
      internalFormMetadata: internalFormMetadata
    });
    var newAppliedChangesHistory = prepareAppliedChangesHistoryForSingleChange({
      currentAppliedChangesHistory: appliedChangesHistory,
      appId: appId,
      changeId: changeId,
      newSingleAppChange: singleAppChange
    });
    setState({
      appliedChangesHistory: newAppliedChangesHistory
    });
  };
};